export default "__VITE_ASSET__DnlpxOTu__"